import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function emailATSValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const email = (control.value || '').toLowerCase();

    if (!email) {
      return null;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    if (!emailRegex.test(email)) {
      return { emailInvalido: true };
    }

    const dominio = 'atsinformatica.com.br';
    if (!email.endsWith(`@${dominio.toLowerCase()}`)) {
      return { dominioInvalido: true };
    }

    return null;
  };
}
